

export const frontMatter = {
	title: 'Get country list',
	sidebar_label: 'Get a list of countries',
	sidebar_position: 2,
	tags: [
		'country_list',
		'javascript'
	],
	keywords: [
		'country_list',
		'javascript'
	],
	description: 'Get information about your users by adding a list of countries to your trading app. Learn how to do that with this JavaScript API example.'
};
export const contentTitle = undefined;
export const metadata = {
  "id": "languages/javascript/get-country-list/index",
  "title": "Get country list",
  "description": "Get information about your users by adding a list of countries to your trading app. Learn how to do that with this JavaScript API example.",
  "source": "@site/docs/languages/javascript/get-country-list/index.md",
  "sourceDirName": "languages/javascript/get-country-list",
  "slug": "/languages/javascript/get-country-list/",
  "permalink": "/docs/languages/javascript/get-country-list/",
  "draft": false,
  "unlisted": false,
  "tags": [
    {
      "label": "country_list",
      "permalink": "/docs/tags/country-list"
    },
    {
      "label": "javascript",
      "permalink": "/docs/tags/javascript"
    }
  ],
  "version": "current",
  "lastUpdatedAt": 1727934930000,
  "sidebarPosition": 2,
  "frontMatter": {
    "title": "Get country list",
    "sidebar_label": "Get a list of countries",
    "sidebar_position": 2,
    "tags": [
      "country_list",
      "javascript"
    ],
    "keywords": [
      "country_list",
      "javascript"
    ],
    "description": "Get information about your users by adding a list of countries to your trading app. Learn how to do that with this JavaScript API example."
  },
  "sidebar": "tutorialSidebar",
  "previous": {
    "title": "WebSocket connection",
    "permalink": "/docs/languages/javascript/websocket-connection/"
  },
  "next": {
    "title": "Guides",
    "permalink": "/docs/category/guides"
  }
};
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    admonition: "admonition",
    code: "code",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "To get a list of countries, update the open event listener using the following approach:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        metastring: "title=\"index.js\" showLineNumbers",
        children: "const ping_interval = 12000; // it's in milliseconds, which equals to 120 seconds\nlet interval;\n// subscribe to `open` event\nwebsocket.addEventListener('open', (event) => {\n  console.log('websocket connection established: ', event);\n  const payload = JSON.stringify({\n    residence_list: 1,\n  });\n  websocket.send(payload);\n\n  // to Keep the connection alive\n  interval = setInterval(() => {\n    const sendMessage = JSON.stringify({ ping: 1 });\n    websocket.send(sendMessage);\n  }, ping_interval);\n});\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Now, update the ", _jsx(_components.code, {
        children: "message"
      }), " event listener to render the data:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        metastring: "title=\"index.js\" showLineNumbers",
        children: "// subscribe to `message` event\nwebsocket.addEventListener('message', (event) => {\n  const receivedMessage = JSON.parse(event.data);\n  switch (receivedMessage.msg_type) {\n    case 'residence_list':\n      console.log('list of countries', receivedMessage.residence_list);\n      break;\n    case 'ping':\n      console.log('ping/pong response: ', receivedMessage.ping);\n      break;\n    default:\n      console.log('received message: ', receivedMessage);\n      break;\n  }\n});\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "The response should be an object:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-json",
        metastring: "showLineNumbers",
        children: "{\n  \"echo_req\": {\n    \"req_id\": 1,\n    \"residence_list\": 1\n  },\n  \"msg_type\": \"residence_list\",\n  \"req_id\": 1,\n  \"residence_list\": [\n    {\n      \"identity\": {\n        \"services\": {\n          \"idv\": {\n            \"documents_supported\": {},\n            \"has_visual_sample\": 0,\n            \"is_country_supported\": 0\n          },\n          \"onfido\": {\n            \"documents_supported\": {},\n            \"is_country_supported\": 0\n          }\n        }\n      },\n      \"phone_idd\": \"35818\",\n      \"text\": \"Aland Islands\",\n      \"value\": \"ax\"\n    },\n    {\n      \"identity\": {\n        \"services\": {\n          \"idv\": {\n            \"documents_supported\": {},\n            \"has_visual_sample\": 0,\n            \"is_country_supported\": 0\n          },\n          \"onfido\": {\n            \"documents_supported\": {\n              \"driving_licence\": {\n                \"display_name\": \"Driving Licence\"\n              },\n              \"national_identity_card\": {\n                \"display_name\": \"National Identity Card\"\n              },\n              \"passport\": {\n                \"display_name\": \"Passport\"\n              }\n            },\n            \"is_country_supported\": 1\n          }\n        }\n      },\n      \"phone_idd\": \"355\",\n      \"text\": \"Albania\",\n      \"tin_format\": [\"^[A-Ta-t0-9]\\\\d{8}[A-Wa-w]$\"],\n      \"value\": \"al\"\n    }\n  ]\n}\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "With this call, you will get useful information about supported countries, such as:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["A ", _jsx(_components.code, {
          children: "2-letter"
        }), " code for each country"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "Identity"
        }), " service providers for each country"]
      }), "\n", _jsxs(_components.li, {
        children: ["Country Tax Identifier Format (", _jsx(_components.code, {
          children: "tin_format"
        }), ")"]
      }), "\n", _jsx(_components.li, {
        children: "etc."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "This can be useful for account creation forms, in which you need to ask users to provide validated information about their identity base, depending on their country of residence."
    }), "\n", _jsx(_components.admonition, {
      type: "caution",
      children: _jsx(_components.p, {
        children: "For address and tax ID validations, please use the provided 'tin_format' for the country."
      })
    }), "\n", _jsx(_components.p, {
      children: "User's country is important for your next steps. It determines which assets and features they can use."
    }), "\n", _jsx(_components.admonition, {
      type: "tip",
      children: _jsx(_components.p, {
        children: "It's better to get the list of countries before populating your form."
      })
    }), "\n", _jsx(_components.admonition, {
      type: "danger",
      children: _jsxs(_components.p, {
        children: ["You will need detailed content about ", _jsx(_components.code, {
          children: "IDV"
        }), " and ", _jsx(_components.code, {
          children: "ONFIDO"
        }), " identity services, their differences and possibilities."]
      })
    }), "\n", _jsx(_components.p, {
      children: "Your final code will be:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        metastring: "title=\"index.js\" showLineNumbers",
        children: "const app_id = 1089; // Replace with your app_id or leave as 1089 for testing.\nconst websocket = new WebSocket(`wss://ws.derivws.com/websockets/v3?app_id=${app_id}`);\nconst ping_interval = 12000; // it's in milliseconds, which equals to 120 seconds\nlet interval;\n\n// subscribe to `open` event\nwebsocket.addEventListener('open', (event) => {\n  console.log('websocket connection established: ', event);\n  const payload = JSON.stringify({\n    residence_list: 1,\n  });\n  websocket.send(payload);\n\n  // to Keep the connection alive\n  interval = setInterval(() => {\n    const sendMessage = JSON.stringify({ ping: 1 });\n    websocket.send(sendMessage);\n  }, ping_interval);\n});\n\n// subscribe to `message` event\nwebsocket.addEventListener('message', (event) => {\n  const receivedMessage = JSON.parse(event.data);\n  switch (receivedMessage.msg_type) {\n    case 'residence_list':\n      console.log('list of countries', receivedMessage.residence_list);\n      break;\n    case 'ping':\n      console.log('ping/pong response: ', receivedMessage.ping);\n      break;\n    default:\n      console.log('received message: ', receivedMessage);\n      break;\n  }\n});\n\n// subscribe to `close` event\nwebsocket.addEventListener('close', (event) => {\n  console.log('websocket connectioned closed: ', event);\n  clearInterval(interval);\n});\n\n// subscribe to `error` event\nwebsocket.addEventListener('error', (event) => {\n  console.log('an error happend in our websocket connection', event);\n});\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

